/* unplugin-vue-components disabled */import script from "./mg-author-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-author-menu.vue?vue&type=script&setup=true&lang=js"

import "./mg-author-menu.vue?vue&type=style&index=0&id=2ffdc2b1&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffdc2b1"]])

export default __exports__